import { useEffect, useState } from 'react';
import { getCoverageLabels } from '../api/portalService';

/**
 * Nombres fijos para las claves del tarifador que el catálogo `uwOfferCoverages`
 * no trae (riders fijos de MX). Sin esto, tras un F5 en /status la tarjeta
 * mostraba la clave cruda (`terminal_illness`). El catálogo pisa este mapa.
 */
export const FALLBACK_COVERAGE_LABELS: Record<string, string> = {
  terminal_illness: 'Pago Anticipado por Enfermedad Terminal',
};

/**
 * Nombres de las coberturas adicionales (catálogo `uwOfferCoverages` de
 * api-client). Se pide una vez por sesión (caché del servicio); si falla, quedan
 * los nombres fijos y, para el resto, la tarjeta muestra la clave cruda.
 */
export function useCoverageLabels(enabled = true): Record<string, string> {
  const [labels, setLabels] = useState<Record<string, string>>(FALLBACK_COVERAGE_LABELS);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    getCoverageLabels().then((catalog) => {
      if (!cancelled) setLabels({ ...FALLBACK_COVERAGE_LABELS, ...catalog });
    });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return labels;
}
